import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/AboutView.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/ProductsView.vue')
  },
  {
    path: '/application',
    name: 'application',
    component: () => import('@/views/ApplicationView.vue')
  },
  {
    path: '/quality',
    name: 'quality',
    component: () => import('@/views/QualityView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/ContactView.vue')
  },
  {
    path: '/prolist',
    name: 'prolist',
    component: () => import('@/views/ProductListView.vue')
  },
  {
    path: '/mems',
    name: 'mems',
    component: () => import('@/views/MEMSView.vue')
  },
  {
    path: '/proshow',
    name: 'proshow',
    component: () => import('@/views/ProductShowView.vue')
  },
  {
    path: '/newsshow',
    name: 'newsshow',
    component: () => import('@/views/NewsShowView.vue')
  },
  {
    path: '/appshow',
    name: 'appshow',
    component: () => import('@/views/AppShowView.vue')
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('@/views/InfoView.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/SearchView.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/PrivacyView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/investor',
    name: 'investor',
    redirect: '/investor/disclosure?tab=1'
  },
  {
    path: '/investor/disclosure',
    name: 'investor-disclosure',
    component: () => import('@/views/InvestorDisclosureView.vue')
  },
  {
    path: '/investor/governance',
    name: 'investor-governance',
    component: () => import('@/views/InvestorGovernanceView.vue')
  },
  {
    path: '/investor/stock',
    name: 'investor-stock',
    component: () => import('@/views/InvestorStockView.vue')
  },
  {
    path: '/investor/log',
    name: 'investor-log',
    component: () => import('@/views/InvestorLogView.vue')
  },
  {
    path: '/investor/contact',
    name: 'investor-contact',
    component: () => import('@/views/InvestorContactView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash && (to.path === '/about' || to.path === '/application' || to.path === '/quality')) {
      // 关于我们、应用领域、质量管理页面由组件自身处理锚点滚动（居中显示）
      return
    }
    if (to.hash) {
      // 延迟执行，确保DOM已渲染
      return new Promise((resolve) => {
        // 多次尝试，确保元素已渲染
        const attemptScroll = (attempts = 0) => {
          if (attempts > 30) {
            // 如果多次尝试都失败，返回当前位置，不重置到顶部
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop
            resolve({ x: 0, y: currentScroll })
            return
          }
          
          const element = document.querySelector(to.hash)
          if (element) {
            // 获取元素的实际位置
            let elementTop
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop
            
            // 尝试使用offsetTop（对于普通定位元素）
            if (element.offsetTop > 0) {
              elementTop = element.offsetTop
            } else {
              // 如果offsetTop为0，可能是绝对定位元素，使用getBoundingClientRect
              const rect = element.getBoundingClientRect()
              if (rect.top !== 0 || rect.height !== 0) {
                elementTop = rect.top + scrollTop
              } else {
                // 元素可能还未完全渲染，延迟重试
                setTimeout(() => attemptScroll(attempts + 1), 50)
                return
              }
            }
            
            // 头部高度：5rem = 80px
            const headerHeight = 80
            // .dingw 的负margin：-100px（桌面端）或 -5rem（移动端，约80px）
            const dingwOffset = window.innerWidth >= 1000 ? 100 : 80
            // 计算目标位置：元素位置 - 头部高度 + dingw的负margin（因为要补偿负margin）
            const targetPosition = elementTop - headerHeight + dingwOffset
            
            // 直接跳转，不使用平滑滚动
            window.scrollTo(0, Math.max(0, targetPosition))
            
            // 立即返回目标位置，防止回到顶部
            resolve({ x: 0, y: targetPosition })
          } else {
            // 元素还未渲染，延迟重试
            setTimeout(() => attemptScroll(attempts + 1), 50)
          }
        }
        
        // 初始延迟，确保路由切换和组件渲染完成
        setTimeout(() => {
          attemptScroll()
        }, 200)
      })
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
